import { render, staticRenderFns } from "./CartPage.vue?vue&type=template&id=4cc37e30&scoped=true"
import script from "./CartPage.vue?vue&type=script&lang=js"
export * from "./CartPage.vue?vue&type=script&lang=js"
import style0 from "./CartPage.vue?vue&type=style&index=0&id=4cc37e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc37e30",
  null
  
)

export default component.exports